import { render, staticRenderFns } from "./CriterionGroupTemplate.vue?vue&type=template&id=1210b502&"
import script from "./CriterionGroupTemplate.vue?vue&type=script&lang=js&"
export * from "./CriterionGroupTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/Portal (Dev)/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1210b502')) {
      api.createRecord('1210b502', component.options)
    } else {
      api.reload('1210b502', component.options)
    }
    module.hot.accept("./CriterionGroupTemplate.vue?vue&type=template&id=1210b502&", function () {
      api.rerender('1210b502', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/criterion/template/CriterionGroupTemplate.vue"
export default component.exports